import { relativeStrengthIndex } from '../../indicators.js';
import type { SupportingMethod } from '../types.js';
import { lastTwoPivots } from '../utils.js';

export const rsiDivergence: SupportingMethod = ({ candles, direction }) => {
  if (candles.length < 40 || direction === 'neutral') {
    return { id: 'MO-001', name: 'RSI divergence', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Insufficient candle history or no Core direction.', dataSufficient: false, sampleSize: candles.length };
  }
  const closes = candles.map((c) => c.close);
  const rsi = relativeStrengthIndex(closes, 14);
  const priceKind = direction === 'long' ? 'low' : 'high';
  const pair = lastTwoPivots(closes, priceKind, 3);
  if (!pair) {
    return { id: 'MO-001', name: 'RSI divergence', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'No two confirmed price pivots for divergence comparison.', dataSufficient: false, sampleSize: candles.length };
  }
  const [a, b] = pair;
  const rsiA = rsi[a];
  const rsiB = rsi[b];
  if (rsiA === undefined || rsiB === undefined || !Number.isFinite(rsiA) || !Number.isFinite(rsiB)) {
    return { id: 'MO-001', name: 'RSI divergence', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'RSI is not fully formed at the latest pivots.', dataSufficient: false, sampleSize: candles.length };
  }
  const priceA = closes[a]!;
  const priceB = closes[b]!;
  const bullish = direction === 'long' && priceB < priceA * 0.999 && rsiB > rsiA + 2;
  const bearish = direction === 'short' && priceB > priceA * 1.001 && rsiB < rsiA - 2;
  const aligned = bullish || bearish;
  return {
    id: 'MO-001',
    name: 'RSI divergence',
    status: 'experimental',
    authority: 1,
    rawSignal: aligned ? 1 : 0,
    contribution: aligned ? 1 : 0,
    direction,
    finding: aligned
      ? `Divergence supports ${direction}: price pivot moved ${direction === 'long' ? 'lower' : 'higher'} while RSI moved in the opposite direction (${rsiA.toFixed(1)} → ${rsiB.toFixed(1)}).`
      : 'No qualifying RSI divergence aligned with the Core direction.',
    dataSufficient: true,
    sampleSize: candles.length,
  };
};
